import {
  ENTER_EXIT_EFFECT_IDS, ENTER_EFFECT_IDS, EXIT_EFFECT_IDS,
  WRITING_HAND_CONTENT_IDS, DRAWING_HAND_CONTENT_IDS
} from './'

export const CATEGORIES = {
  UNLISTED: 'Unlisted',
  WRITING: 'Writing',
  TEXT: 'Text effects',
  SLIDE: 'Slide',
  DRAWING: 'Drawing',
  REVEAL: 'Reveal',
  MAN_HAND: 'Male hand',
  WOMAN_HAND: 'Female hand',
  SOUND: 'Sound Effects'
}

export const LABELS = {
  IS_NEW: 'isNew',
  COMING_SOON: 'comingSoon'
}

export const GROUP_EFFECT = {effectId: '', icon: 'linear_scale'}

export const NO_HAND_EFFECT = {
  effectId: null,
  displayedName: 'No hand',
  type: 'hand',
  image: 'no_hand_effect.svg',
  category: CATEGORIES.UNLISTED
}

export const NO_SOUND_EFFECT = {
  id: null,
  name: 'No Sound',
  type: 'sound',
  image: 'no_sound_effect.svg',
  category: CATEGORIES.UNLISTED
}

export const NO_EFFECT_DEFINITION = {
  effectId: ENTER_EXIT_EFFECT_IDS.NO_EFFECT,
  displayedName: 'No Effect',
  icon: 'none',
  gif: 'no_effect.svg',
  jpg: 'no_effect.svg',
  category: CATEGORIES.UNLISTED
}

export const ENTER_EFFECTS_DEFINITION = [
  {
    effectId: ENTER_EFFECT_IDS.SLIDE_FROM_LEFT,
    type: 'regular',
    displayedName: 'Right',
    gif: 'effect_slide_from_right.gif',
    jpg: 'effect_slide_from_right_static.gif',
    icon: 'slide-left',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: ENTER_EFFECT_IDS.SLIDE_FROM_RIGHT,
    type: 'regular',
    displayedName: 'Left',
    gif: 'effect_slide_from_left.gif',
    jpg: 'effect_slide_from_left_static.gif',
    icon: 'slide-right',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: ENTER_EFFECT_IDS.SLIDE_FROM_BOTTOM,
    type: 'regular',
    displayedName: 'Up',
    gif: 'effect_slide_from_top.gif',
    jpg: 'effect_slide_from_top_static.gif',
    icon: 'slide-up',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: ENTER_EFFECT_IDS.SLIDE_FROM_TOP,
    type: 'regular',
    displayedName: 'Down',
    gif: 'effect_slide_from_bottom.gif',
    jpg: 'effect_slide_from_bottom_static.gif',
    icon: 'slide-down',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: ENTER_EFFECT_IDS.REVEAL_FROM_LEFT,
    type: 'regular',
    displayedName: 'Right',
    gif: 'effect_reveal_from_left.gif',
    jpg: 'effect_reveal_from_left_static.gif',
    icon: 'slide-left',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: ENTER_EFFECT_IDS.REVEAL_FROM_RIGHT,
    type: 'regular',
    displayedName: 'Left',
    gif: 'effect_reveal_from_right.gif',
    jpg: 'effect_reveal_from_right_static.gif',
    icon: 'slide-right',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: ENTER_EFFECT_IDS.REVEAL_FROM_BOTTOM,
    type: 'regular',
    displayedName: 'Up',
    gif: 'effect_reveal_from_bottom.gif',
    jpg: 'effect_reveal_from_bottom_static.gif',
    icon: 'slide-up',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: ENTER_EFFECT_IDS.REVEAL_FROM_TOP,
    type: 'regular',
    displayedName: 'Down',
    gif: 'effect_reveal_from_top.gif',
    jpg: 'effect_reveal_from_top_static.gif',
    icon: 'slide-down',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: ENTER_EFFECT_IDS.POP_IN,
    type: 'regular',
    displayedName: 'Pop',
    gif: 'effect_enter_pop.gif',
    jpg: 'effect_enter_pop_static.gif',
    icon: 'pop-in',
    category: CATEGORIES.UNLISTED
  },
  {
    effectId: ENTER_EFFECT_IDS.FADE_IN,
    type: 'regular',
    displayedName: 'Fade',
    gif: 'effect_enter_fade.gif',
    jpg: 'effect_fade.gif',
    icon: 'fade',
    category: CATEGORIES.UNLISTED
  }, {
    effectId: ENTER_EFFECT_IDS.MONTAGE_IN,
    type: 'regular',
    displayedName: 'Montage',
    gif: 'effect_reveal_montage.gif',
    jpg: 'effect_reveal_montage_static.png',
    icon: 'pop-in',
    category: CATEGORIES.REVEAL
  }, {
    effectId: ENTER_EFFECT_IDS.SMEAR_IN,
    type: 'regular',
    displayedName: 'Smear',
    gif: 'effect_reveal_smear.gif',
    jpg: 'effect_reveal_smear_static.png',
    icon: 'pop-in',
    category: CATEGORIES.REVEAL
  }
]

export const EXIT_EFFECTS_DEFINITION = [
  {
    effectId: EXIT_EFFECT_IDS.SLIDE_TO_RIGHT,
    type: 'regular',
    displayedName: 'Right',
    gif: 'effect_slide_to_right.gif',
    jpg: 'effect_slide_to_right_static.gif',
    icon: 'slide-left',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: EXIT_EFFECT_IDS.SLIDE_TO_LEFT,
    type: 'regular',
    displayedName: 'Left',
    gif: 'effect_slide_to_left.gif',
    jpg: 'effect_slide_to_left_static.gif',
    icon: 'slide-right',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: EXIT_EFFECT_IDS.SLIDE_TO_TOP,
    type: 'regular',
    displayedName: 'Up',
    gif: 'effect_slide_to_top.gif',
    jpg: 'effect_slide_to_top_static.gif',
    icon: 'slide-up',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: EXIT_EFFECT_IDS.SLIDE_TO_BOTTOM,
    type: 'regular',
    displayedName: 'Down',
    gif: 'effect_slide_to_bottom.gif',
    jpg: 'effect_slide_to_bottom_static.gif',
    icon: 'slide-down',
    category: CATEGORIES.SLIDE
  },
  {
    effectId: EXIT_EFFECT_IDS.REVEAL_TO_RIGHT,
    type: 'regular',
    displayedName: 'Right',
    gif: 'effect_reveal_to_right.gif',
    jpg: 'effect_reveal_to_right_static.gif',
    icon: 'slide-left',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: EXIT_EFFECT_IDS.REVEAL_TO_LEFT,
    type: 'regular',
    displayedName: 'Left',
    gif: 'effect_reveal_to_left.gif',
    jpg: 'effect_reveal_to_left_static.gif',
    icon: 'slide-right',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: EXIT_EFFECT_IDS.REVEAL_TO_TOP,
    type: 'regular',
    displayedName: 'Up',
    gif: 'effect_reveal_to_top.gif',
    jpg: 'effect_reveal_to_top_static.gif',
    icon: 'slide-up',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: EXIT_EFFECT_IDS.REVEAL_TO_BOTTOM,
    type: 'regular',
    displayedName: 'Down',
    gif: 'effect_reveal_to_bottom.gif',
    jpg: 'effect_reveal_to_bottom_static.gif',
    icon: 'slide-down',
    category: CATEGORIES.REVEAL
  },
  {
    effectId: EXIT_EFFECT_IDS.POP_OUT,
    type: 'regular',
    displayedName: 'Pop',
    gif: 'effect_exit_pop.gif',
    jpg: 'effect_exit_pop_static.gif',
    icon: 'pop-out',
    category: CATEGORIES.UNLISTED
  },
  {
    effectId: EXIT_EFFECT_IDS.FADE_OUT,
    type: 'regular',
    displayedName: 'Fade',
    gif: 'effect_exit_fade.gif',
    jpg: 'effect_fade.gif',
    icon: 'fade',
    category: CATEGORIES.UNLISTED
  }
]


export const TEXT_EFFECTS_DEFINITION = [
  {
    effectId: 'Hand',
    handContentId: WRITING_HAND_CONTENT_IDS.FEMALE_WHITE_01,
    type: 'text',
    displayedName: 'Hand 01',
    gif: 'word-write-gif-white-1.gif',
    jpg: 'word-write-gif-white-1.png',
    icon: 'hand',
    category: CATEGORIES.TEXT,
    displayedCategory: CATEGORIES.WRITING
  },
  {
    effectId: 'Hand',
    handContentId: WRITING_HAND_CONTENT_IDS.MALE_BLACK_01,
    displayedName: 'Hand 02',
    type: 'text',
    category: CATEGORIES.TEXT,
    gif: 'word-write-gif-black-1.gif',
    jpg: 'word-write-gif-black-1.png',
    icon: 'hand',
    displayedCategory: CATEGORIES.WRITING
  },
  {
    effectId: 'Hand',
    handContentId: WRITING_HAND_CONTENT_IDS.MALE_BLACK_02,
    displayedName: 'Hand 03',
    type: 'text',
    category: CATEGORIES.TEXT,
    gif: 'word-write-gif-black-2.gif',
    jpg: 'word-write-gif-black-2.png',
    icon: 'hand',
    displayedCategory: CATEGORIES.WRITING
  },
  {
    effectId: 'Hand',
    handContentId: WRITING_HAND_CONTENT_IDS.MALE_HISPANIC_01,
    displayedName: 'Hand 04',
    type: 'text',
    category: CATEGORIES.TEXT,
    gif: 'word-write-gif-hisp-1.gif',
    jpg: 'word-write-gif-hisp-1.png',
    icon: 'hand',
    displayedCategory: CATEGORIES.WRITING
  },
  {
    effectId: 'Wave',
    type: 'text',
    displayedName: 'Wave',
    gif: 'text_wave.gif',
    jpg: 'text_wave.jpg',
    icon: 'bounce',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Slide',
    type: 'text',
    displayedName: 'Slide',
    gif: 'text_slide.gif',
    jpg: 'text_slide.jpg',
    icon: 'bounce',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Rise',
    type: 'text',
    displayedName: 'Rise',
    gif: 'text_rise.gif',
    jpg: 'text_rise.jpg',
    icon: 'bounce',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Appear',
    type: 'text',
    displayedName: 'Appear',
    gif: 'text_appear.gif',
    jpg: 'text_appear.jpg',
    icon: 'appear',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Drop',
    type: 'text',
    displayedName: 'Scale',
    gif: 'text_drop.gif',
    jpg: 'text_drop.jpg',
    icon: 'drop',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Type',
    type: 'text',
    displayedName: 'Type',
    gif: 'text_type.gif',
    jpg: 'text_type.jpg',
    icon: 'type',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Roll',
    type: 'text',
    displayedName: 'Roll',
    gif: 'text_roll.gif',
    jpg: 'text_roll.jpg',
    icon: 'roll',
    category: CATEGORIES.TEXT
  },
  {
    effectId: 'Bounce',
    type: 'text',
    displayedName: 'Bounce',
    gif: 'text_bounce.gif',
    jpg: 'text_bounce.jpg',
    icon: 'bounce',
    category: CATEGORIES.TEXT
  }
]

export const HAND_EFFECTS_DEFINITION = [
  NO_HAND_EFFECT,
  {
    effectId: 'defaultHand',
    displayedName: 'Hand 1',
    type: 'hand',
    image: 'hand_effect.png',
    category: CATEGORIES.WOMAN_HAND
  },
  {
    effectId: 'ethnicHand',
    displayedName: 'Hand 2',
    type: 'hand',
    image: 'ethnic_hand_effect.png',
    category: CATEGORIES.WOMAN_HAND
  },
  {
    effectId: 'blackManHand',
    displayedName: 'Hand 1',
    type: 'hand',
    image: 'black_man_hand.png',
    category: CATEGORIES.MAN_HAND
  },
  {
    effectId: 'whiteManHand',
    displayedName: 'Hand 2',
    type: 'hand',
    image: 'white_man_hand.png',
    category: CATEGORIES.MAN_HAND
  }
]

export const DRAW_EFFECTS_DEFINITION = [
  {
    effectId: ENTER_EFFECT_IDS.ZIGZAG_IN,
    handContentId: DRAWING_HAND_CONTENT_IDS.NO_HAND,
    displayedName: 'No hand',
    type: 'no-text',
    category: CATEGORIES.DRAWING,
    gif: 'draw_hand_effect_no_hand.gif',
    jpg: 'draw_hand_effect_no_hand.png',
    icon: 'sign'
  },
  {
    effectId: ENTER_EFFECT_IDS.ZIGZAG_IN,
    handContentId: DRAWING_HAND_CONTENT_IDS.FEMALE_WHITE_01,
    displayedName: 'Hand 01',
    type: 'no-text',
    category: CATEGORIES.DRAWING,
    gif: 'draw_hand_effect_female_01.gif',
    jpg: 'draw_hand_effect_female_01.png',
    icon: 'hand'
  },
  {
    effectId: ENTER_EFFECT_IDS.ZIGZAG_IN,
    handContentId: DRAWING_HAND_CONTENT_IDS.MALE_BLACK_01,
    displayedName: 'Hand 02',
    type: 'no-text',
    category: CATEGORIES.DRAWING,
    gif: 'draw_hand_effect_black_01.gif',
    jpg: 'draw_hand_effect_black_01.png',
    icon: 'hand'
  },
  {
    effectId: ENTER_EFFECT_IDS.ZIGZAG_IN,
    handContentId: DRAWING_HAND_CONTENT_IDS.MALE_BLACK_02,
    displayedName: 'Hand 03',
    type: 'no-text',
    category: CATEGORIES.DRAWING,
    gif: 'draw_hand_effect_black_02.gif',
    jpg: 'draw_hand_effect_black_02.png',
    icon: 'hand'
  },
  {
    effectId: ENTER_EFFECT_IDS.ZIGZAG_IN,
    handContentId: DRAWING_HAND_CONTENT_IDS.MALE_HISPANIC_01,
    displayedName: 'Hand 04',
    type: 'no-text',
    category: CATEGORIES.DRAWING,
    gif: 'draw_hand_effect_hispanic_01.gif',
    jpg: 'draw_hand_effect_hispanic_01.png',
    icon: 'hand'
  }
]

export const ENTER_SAO_EFFECTS = [{
  ...NO_EFFECT_DEFINITION,
  category: CATEGORIES.SOUND
}, {
  effectId: ENTER_EFFECT_IDS.FADE_IN,
  type: 'regular',
  displayedName: 'Fade',
  gif: 'effect_enter_fade.gif',
  jpg: 'effect_fade.gif',
  icon: 'fade',
  category: CATEGORIES.SOUND,
  displayedCategory: CATEGORIES.SOUND
}]

export const EXIT_SAO_EFFECTS = [{
  ...NO_EFFECT_DEFINITION,
  category: CATEGORIES.SOUND
}, {
  effectId: EXIT_EFFECT_IDS.FADE_OUT,
  type: 'regular',
  displayedName: 'Fade',
  gif: 'effect_enter_fade.gif',
  jpg: 'effect_fade.gif',
  icon: 'fade',
  category: CATEGORIES.SOUND,
  displayedCategory: CATEGORIES.SOUND
}]

export const EFFECT_DURATION = 0.5